"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnType = void 0;
var ColumnType;
exports.ColumnType = ColumnType;

(function (ColumnType) {
  ColumnType["BOOLEAN"] = "boolean";
  ColumnType["DATETIME"] = "datetime";
  ColumnType["DATE_RANGE"] = "dateRange";
  ColumnType["DATE"] = "date";
  ColumnType["NUMBER"] = "number";
  ColumnType["TEXT"] = "text";
  ColumnType["TIME"] = "time";
  ColumnType["FOREIGN_ID"] = "foreignId";
})(ColumnType || (exports.ColumnType = ColumnType = {}));